
export const ROLE_LIST_STATES: any[] = [
    {
        id: 'ACTIVE',
        name: 'Активен',
    },
    {
        id: 'BLOCKED',
        name: 'Заблокирован'
    },
];